<template>
  <div class="full-page">
    <!-- 背景图片 -->
    <img :src="Image" alt="背景图" class="full-image" />

    <div class="data-container">
      <!-- 频率数据（新增泵运行状态颜色绑定） -->
      <span
        class="data-item freq-item"
        style="left: 69.5%; top: 51%;"
        :class="{ 'running': pumpStatus.HLSW_HN1013_SB_1 === '开启' }"
      >
        1#&nbsp;{{ formatFreq(feq01) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 69.5%; top: 63%;"
        :class="{ 'running': pumpStatus.HLSW_HN1013_SB_2 === '开启' }"
      >
        2#&nbsp;{{ formatFreq(feq02) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 69.5%; top: 75%;"
        :class="{ 'running': pumpStatus.HLSW_HN1013_SB_3 === '开启' }"
      >
        3#&nbsp;{{ formatFreq(feq03) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 17.5%; top: 51%;"
        :class="{ 'running': pumpStatus.HLSW_HN1013_SB_4 === '开启' }"
      >
        1#&nbsp;{{ formatFreq(feq04) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 17.5%; top: 63%;"
        :class="{ 'running': pumpStatus.HLSW_HN1013_SB_5 === '开启' }"
      >
        2#&nbsp;{{ formatFreq(feq05) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 17.5%; top: 75%;"
        :class="{ 'running': pumpStatus.HLSW_HN1013_SB_6 === '开启' }"
      >
        3#&nbsp;{{ formatFreq(feq06) }} Hz
      </span>

      <!-- 消息滚动提示框（5条消息 + 放大尺寸 + 左对齐 + 状态颜色） -->
      <div class="msg-box">
        <div class="msg-scroll" :style="{ transform: `translateY(-${scrollOffset}px)` }">
          <div
            class="msg-item"
            v-for="(msg, idx) in infiniteMsgList"
            :key="idx"
            :class="{
              'msg-running': msg.includes('正在运行'),
              'msg-stopped': msg.includes('未开机')
            }"
          >
            {{ msg }}
          </div>
        </div>
      </div>

      <!-- 机组负荷比 -->
      <span
        class="data-item jz-number"
        style="left: 42%; top: 42%;"
      >
        {{C1_Compressor_load_one}}%
      </span>
      <span
        class="data-item jz-number"
        style="left: 46.7%; top: 42%;"
      >
        {{C1_Compressor_load_two}}%
      </span>
      <span
        class="data-item jz-number"
        style="left: 42%; top: 58%;"
      >
        {{C2_Compressor_load_one}}%
      </span>
      <span
        class="data-item jz-number"
        style="left: 46.7%; top: 58%;"
      >
        {{C2_Compressor_load_two}}%
      </span>
      <span
        class="data-item jz-number"
        style="left: 42%; top: 75%;"
      >
        {{C3_Compressor_load_one}}%
      </span>
      <span
        class="data-item jz-number"
        style="left: 46.7%; top: 75%;"
      >
        {{C3_Compressor_load_two}}%
      </span>

      <!-- 机组名称（动态颜色） -->
      <span
        class="data-item jz-number"
        style="left: 44.5%; top: 47%;"
        :style="{ color: Number(JZ_status) === 1 ? '#00cc00' : 'black' }"
      >
        1#
      </span>
      <span
        class="data-item jz-number"
        style="left: 44.5%; top: 64%;"
        :style="{ color: Number(JZ_status1) === 1 ? '#00cc00' : 'black' }"
      >
        2#
      </span>
      <span
        class="data-item jz-number"
        style="left: 44.5%; top: 80.5%;"
        :style="{ color: Number(JZ_status2) === 1 ? '#00cc00' : 'black' }"
      >
        3#
      </span>

      <!-- 机组状态（动态修改内容、颜色、居中） -->
      <span
        class="data-item jz-status"
        style="left: 43%; top: 52%;"
        :style="{ color: Number(JZ_status) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
      >
        {{ Number(JZ_status) === 1 ? '正在运行中' : '未开机' }}
      </span>
      <span
        class="data-item jz-status"
        style="left: 43%; top: 69%;"
        :style="{ color: Number(JZ_status1) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
      >
        {{ Number(JZ_status1) === 1 ? '正在运行中' : '未开机' }}
      </span>
      <span
        class="data-item jz-status"
        style="left: 43%; top: 85.5%;"
        :style="{ color: Number(JZ_status2) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
      >
        {{ Number(JZ_status2) === 1 ? '正在运行中' : '未开机' }}
      </span>

      <!-- 温度数据 -->
      <span class="data-item" style="left: 52%; top: 49%;">&nbsp;{{ Evap_inlet_water_t }} °C</span>
      <span class="data-item" style="left: 52%; top: 52%;">&nbsp;{{ Evap_out_water_Allt }} °C</span>
      <span class="data-item" style="left: 35%; top: 49%;">&nbsp;{{ Cond_inlet_water_t }} °C</span>
      <span class="data-item" style="left: 35%; top: 52%;">&nbsp;{{ Cond_out_water_t }} °C</span>

      <span class="data-item" style="left: 52%; top: 66%;">&nbsp;{{ Evap_inlet_water_t1 }} °C</span>
      <span class="data-item" style="left: 52%; top: 68.7%;">&nbsp;{{ Evap_out_water_Allt1 }} °C</span>
      <span class="data-item" style="left: 35%; top: 66%;">&nbsp;{{ Cond_inlet_water_t1 }} °C</span>
      <span class="data-item" style="left: 35%; top: 68.7%;">&nbsp;{{ Cond_out_water_t1 }} °C</span>

      <span class="data-item" style="left: 52%; top: 85%;">&nbsp;{{ Evap_inlet_water_t2 }} °C</span>
      <span class="data-item" style="left: 52%; top: 88%;">&nbsp;{{ Evap_out_water_Allt2 }} °C</span>
      <span class="data-item" style="left: 35%; top: 85%;">&nbsp;{{ Cond_inlet_water_t2 }} °C</span>
      <span class="data-item" style="left: 35%; top: 88%;">&nbsp;{{ Cond_out_water_t2 }} °C</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HLSWMonitor',
  data() {
    return {
      Image: 'https://hpc.cnhopo.com/hpcimgs/20251225_f0adffa1_HLSWnew.png',
      timer: null,
      scrollTimer: null,
      cookieValue: '', // 存储Cookie值（全局可访问）

      // 频率/温度数据
      feq01: '', feq02: '', feq03: '', feq04: '', feq05: '', feq06: '',
      Evap_inlet_water_t: '', Evap_out_water_Allt: '', Cond_inlet_water_t: '', Cond_out_water_t: '',
      Evap_inlet_water_t1: '', Evap_out_water_Allt1: '', Cond_inlet_water_t1: '', Cond_out_water_t1: '',
      Evap_inlet_water_t2: '', Evap_out_water_Allt2: '', Cond_inlet_water_t2: '', Cond_out_water_t2: '',

      // 机组状态存储
      JZ_status: '',   // 1#机组状态
      JZ_status1: '',  // 2#机组状态
      JZ_status2: '',  // 3#机组状态

      //机组负荷比
      C1_Compressor_load_one:'',  //1号机组负荷比1
      C1_Compressor_load_two:'',  //1号机组负荷比2
      C2_Compressor_load_one:'',  //2号机组负荷比1
      C2_Compressor_load_two:'',  //2号机组负荷比2
      C3_Compressor_load_one:'',  //3号机组负荷比1
      C3_Compressor_load_two:'',  //3号机组负荷比2

      // 泵状态存储
      pumpStatus: {
        HLSW_HN1013_SB_1: '', // 冷冻泵1
        HLSW_HN1013_SB_2: '', // 冷冻泵2
        HLSW_HN1013_SB_3: '', // 冷冻泵3
        HLSW_HN1013_SB_4: '', // 冷却泵1
        HLSW_HN1013_SB_5: '', // 冷却泵2
        HLSW_HN1013_SB_6: ''  // 冷却泵3
      },
      // 泵ID和名称的映射关系
      pumpMap: {
        HLSW_HN1013_SB_1: '1#冷冻泵',
        HLSW_HN1013_SB_2: '2#冷冻泵',
        HLSW_HN1013_SB_3: '3#冷冻泵',
        HLSW_HN1013_SB_4: '1#冷却泵',
        HLSW_HN1013_SB_5: '2#冷却泵',
        HLSW_HN1013_SB_6: '3#冷却泵'
      },

      // 消息滚动配置【核心修改：调整为5条显示、放大尺寸】
      baseMsgList: [], // 动态生成消息列表
      infiniteMsgList: [], // 无限滚动列表
      scrollOffset: 0, // 纯累加偏移量（无跳转）
      itemHeight: 24, // 消息高度（放大：原14 → 24，包含字体和间距）
      showCount: 5 // 固定显示5条（原4 → 5）
    }
  },
  created() {
    // 初始生成空列表，后续由接口数据填充
    this.infiniteMsgList = [...this.baseMsgList];
    // 1. 从localStorage读取user字段（兜底空字符串避免JSON.parse报错）
    const userStr = localStorage.getItem("user") || '{}';
    // 2. 解析JSON字符串为对象
    const userObj = JSON.parse(userStr);
    // 3. 提取目标cookie值并赋值给组件的data变量（关键修复）
    this.cookieValue = userObj.cookie || '';
    // 打印验证
    console.log("HLSW页面的原始user数据：", userStr);
    console.log("提取出的cookie值：", this.cookieValue); // 打印组件全局的cookieValue
  },
  mounted() {
    // 初始化请求数据
    this.dsfzdata();
    this.pumpdata(); // 现在能拿到cookieValue了
    // 启动定时任务（20秒刷新一次）
    this.startTimer();
    this.startMsgScroll();
  },
  destroyed() { // Vue2使用destroyed替代onUnload（组件销毁）
    this.clearTimer();
    this.clearMsgScroll();
  },
  methods: {
    formatFreq(value) {
      if (value === '' || value === null || value === undefined || isNaN(Number(value))) {
        return 'NaN';
      }
      const num = Number(value);
      if (num < 0 || Object.is(num, -0)) {
        return 'NaN';
      }
      return Math.floor(num);
    },
    startTimer() {
      // 定时刷新机组和泵数据（20秒一次）
      this.timer = setInterval(() => {
        this.dsfzdata();
        this.pumpdata();
      }, 20000);
    },
    clearTimer() {
      if (this.timer) clearInterval(this.timer);
    },
    // 纯向上滚动（无任何跳转，4秒一次缓慢平滑）
    startMsgScroll() {
      this.scrollTimer = setInterval(() => {
        this.scrollOffset += this.itemHeight;
        // 偏移量超过1个原始列表高度时，截取（避免数值过大）
        const singleListHeight = this.baseMsgList.length * this.itemHeight;
        if (singleListHeight > 0 && this.scrollOffset >= singleListHeight) {
          this.scrollOffset = this.scrollOffset - singleListHeight;
        }
      }, 4000); // 每隔4秒滚动一次
    },
    clearMsgScroll() {
      if (this.scrollTimer) clearInterval(this.scrollTimer);
    },
    // 根据机组和泵状态生成左对齐消息列表
    generateMsgList() {
      // 机组状态消息（左对齐格式）
      const jzMsg = [
        `1#机组${Number(this.JZ_status) === 1 ? '正在运行' : '未开机'}`,
        `2#机组${Number(this.JZ_status1) === 1 ? '正在运行' : '未开机'}`,
        `3#机组${Number(this.JZ_status2) === 1 ? '正在运行' : '未开机'}`,
      ];

      // 泵状态消息（左对齐格式）
      const pumpMsg = [];
      Object.keys(this.pumpMap).forEach(pumpId => {
        const pumpName = this.pumpMap[pumpId];
        const pumpState = this.pumpStatus[pumpId];
        // 根据接口返回的"开启"/"关闭"显示对应状态
        pumpMsg.push(`${pumpName}${pumpState === '开启' ? '正在运行' : '未开机'}`);
      });

      // 合并机组和泵的消息（保持左对齐）
      this.baseMsgList = [...jzMsg, ...pumpMsg];
      // 重新生成无限滚动列表（避免滚动空白）
      this.infiniteMsgList = [...this.baseMsgList, ...this.baseMsgList, ...this.baseMsgList];
    },
    // 机组数据请求
    dsfzdata() {
      // 替换uni.request为axios/fetch - 这里用fetch示例（浏览器原生）
      fetch("https://hpc.cnhopo.com/otherApi/data/get_hlsw01_data", {
        method: 'GET',
        credentials: 'include' // 携带Cookie（跨域需后端配置）
      })
        .then(res => res.json())
        .then(res => {
          console.log("机组数据", res)
          if (res.code === 200) {
            const data = res.data || {};
            // 频率数据
            this.feq01 = data.feq01 || ''; this.feq02 = data.feq02 || '';
            this.feq03 = data.feq03 || ''; this.feq04 = data.feq04 || '';
            this.feq05 = data.feq05 || ''; this.feq06 = data.feq06 || '';
            // 温度数据
            this.Evap_inlet_water_t = data.Evap_inlet_water_t || '';
            this.Evap_out_water_Allt = data.Evap_out_water_Allt || '';
            this.Cond_inlet_water_t = data.Cond_inlet_water_t || '';
            this.Cond_out_water_t = data.Cond_out_water_t || '';
            this.Evap_inlet_water_t1 = data.Evap_inlet_water_t1 || '';
            this.Evap_out_water_Allt1 = data.Evap_out_water_Allt1 || '';
            this.Cond_inlet_water_t1 = data.Cond_inlet_water_t1 || '';
            this.Cond_out_water_t1 = data.Cond_out_water_t1 || '';
            this.Evap_inlet_water_t2 = data.Evap_inlet_water_t2 || '';
            this.Evap_out_water_Allt2 = data.Evap_out_water_Allt2 || '';
            this.Cond_inlet_water_t2 = data.Cond_inlet_water_t2 || '';
            this.Cond_out_water_t2 = data.Cond_out_water_t2 || '';
            this.C1_Compressor_load_one = data.C1_Compressor_load_one || '';
            this.C1_Compressor_load_two = data.C1_Compressor_load_two || '';
            this.C2_Compressor_load_one = data.C2_Compressor_load_one || '';
            this.C2_Compressor_load_two = data.C2_Compressor_load_two || '';
            this.C3_Compressor_load_one = data.C3_Compressor_load_one || '';
            this.C3_Compressor_load_two = data.C3_Compressor_load_two || '';

            // 读取机组状态数据
            this.JZ_status = data.JZ_status || '';
            this.JZ_status1 = data.JZ_status1 || '';
            this.JZ_status2 = data.JZ_status2 || '';

            // 动态生成左对齐消息列表
            this.generateMsgList();
          } else {
            alert('机组数据获取失败'); // 替换uni.showToast
          }
        })
        .catch(err => {
          console.error('机组数据请求失败:', err);
          alert('机组数据网络错误'); // 替换uni.showToast
        })
    },
    // 泵状态请求（批量请求6个泵，带Cookie认证）
    pumpdata() {
      // 修复：先校验cookieValue是否真的为空（排除空字符串/空格）
      const validCookie = this.cookieValue.trim();
      if (!validCookie) {
        console.warn('Cookie值为空，无法请求泵数据');
        // 给泵状态设置默认值
        Object.keys(this.pumpStatus).forEach(pumpId => {
          this.pumpStatus[pumpId] = '关闭';
        });
        this.generateMsgList();
        return;
      }

      // 注意：这里不需要手动拼接Cookie头，交给浏览器自动处理
      console.log("请求泵数据的Cookie值:", validCookie);

      // 定义需要请求的泵ID列表
      const pumpIds = [
        'HLSW_HN1013_SB_1',
        'HLSW_HN1013_SB_2',
        'HLSW_HN1013_SB_3',
        'HLSW_HN1013_SB_4',
        'HLSW_HN1013_SB_5',
        'HLSW_HN1013_SB_6'
      ];

      // 存储所有请求的Promise
      const requestPromises = [];

      // 批量创建请求
      pumpIds.forEach(pumpId => {
        const promise = new Promise((resolve) => {
          // 拼接GET参数
          const params = new URLSearchParams();
          params.append('equ_id', pumpId);

          fetch("otherApi/get_vfd/?" + params.toString(), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
              // 【删除手动拼接的Cookie头】
            },
            // 【关键修复：加回credentials，让浏览器自动携带Cookie】
            credentials: 'include',
            // 【补充：如果后端允许，可加mode: 'cors'（部分场景需要）】
            mode: 'cors'
          })
            .then(res => res.json())
            .then(res => {
              console.log(`${pumpId} 泵数据`, res)
              if (res.code === 200) {
                // 存储泵状态（开启/关闭）
                this.pumpStatus[pumpId] = res.data || '关闭';
              } else {
                // 请求失败时默认状态为关闭
                this.pumpStatus[pumpId] = '关闭';
                console.warn(`${this.pumpMap[pumpId]}数据获取失败:`, res);
              }
              resolve();
            })
            .catch(err => {
              console.error(`${pumpId} 泵请求失败:`, err);
              // 请求失败时默认状态为关闭
              this.pumpStatus[pumpId] = '关闭';
              resolve();
            })
        });
        requestPromises.push(promise);
      });

      // 所有泵请求完成后更新左对齐消息列表
      Promise.all(requestPromises).then(() => {
        this.generateMsgList();
      });
    }
  }
}
</script>

<style scoped>
.full-page {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 999;
  overflow: hidden;
}
.full-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: block;
  margin: 0;
  padding: 0;
  z-index: 1;
  object-fit: fill; /* 替代uni-app的scaleToFill */
}
.data-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}
.data-item {
  position: absolute;
  padding: 5px 10px;
  color: black;
  border-radius: 4px;
  font-weight: bold;
  font-size: 13px;
}

/* 新增：泵频率运行状态样式 */
.freq-item.running {
  color: #00cc00; /* 与机组/滚动消息绿色保持一致 */
}

/* 机组编号样式 */
.jz-number {
  display: inline-block;
  width: 40px; /* 适配编号宽度 */
  text-align: center; /* 编号居中显示 */
  box-sizing: border-box;
}

/* 机组状态样式增强 - 确保居中生效 */
.jz-status {
  display: inline-block;
  width: 90px; /* 固定宽度确保居中效果更明显 */
  box-sizing: border-box;
}

/* 消息框核心样式【核心修改：左对齐、放大尺寸、显示5条 + 状态颜色】 */
.msg-box {
  position: absolute;
  left: 66%; /* 微调位置，适配放大后的宽度 */
  top: 25.5%;  /* 微调位置，避免遮挡 */
  width: 280px; /* 放大宽度：原200 → 280 */
  height: 120px; /* 5条*24px=120px（原56 → 120） */
  overflow: hidden; /* 只显示5条 */
  z-index: 3;
  text-align: left; /* 核心：消息框整体左对齐 */
}
.msg-scroll {
  transition: transform 0.6s ease-out; /* 缓慢平滑滚动：原0.3 → 0.6 */
  will-change: transform; /* 性能优化 */
}
.msg-item {
  height: 24px; /* 放大高度：原14 → 24 */
  line-height: 24px; /* 垂直居中，与高度一致 */
  font-size: 14px; /* 放大字体：原9 → 14 */
  font-weight: bold;
  white-space: nowrap; /* 不换行 */
  margin: 0;
  padding: 0 10px; /* 增加左右内边距，优化左对齐显示 */
  text-align: left; /* 强制每条消息左对齐 */
  width: 100%; /* 确保宽度铺满容器，左对齐生效 */
  box-sizing: border-box;
}
/* 运行中状态 - 绿色字体 */
.msg-running {
  color: #00cc00;
}
/* 未开机状态 - 红色字体 */
.msg-stopped {
  color: #ff0000;
}

/* 兼容默认颜色（防止匹配不到的情况） */
.msg-item:not(.msg-running):not(.msg-stopped) {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Hlsw.vue